import { React, useState, useEffect } from "react";
import "../../styles/Card.css";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import {
  getCertURL,
  getfile,
  getPaymentFileURL,
  getSubmittedFiles,
} from "../../apis/firebasecloud.js";
import { setStatus } from "../../apis/firestoreDatabase";
import Loader from "../loader";
import { async } from "@firebase/util";
import { verificationStatuses } from "../../data/constants";

//for color of status circles
function colorScheme(variable) {
  var color = "yellow";
  if (variable === verificationStatuses.VERIFIED) color = "green";
  else if (variable === verificationStatuses.DENIED) color = "red";
  return color;
}

export default function Card(props) {
  //Use State for invoking close and open button
  const [stateLoader, setStateLoader] = useState("none");
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setDisable(false);
    setShow(false);
    setdeclineButton(false);
  };
  const handleShow = () => setShow(true);

  const [isOpen, setIsOpen] = useState(false);

  function toggleWarningModal() {
    setIsOpen(!isOpen);
  }

  //for disabling document fetching button

  const [disable, setDisable] = useState(false);
  const [declineButton, setdeclineButton] = useState(false);
  let [declineReason, setDeclineReason] = useState(" ");
  let [statusVerify, setstatusVerify] = useState(false);

  //function for sending request to the backend
  async function declineButtonClick({ owner: userId, queryId, owner, name }) {
    setStateLoader("block");
    setStatus("verification.exam@mitwpu.edu.in", queryId, verificationStatuses.DENIED);
    setStatus(userId, queryId, verificationStatuses.DENIED);

    const docs = await getSubmittedFiles(userId, queryId);
    const resp = await axios
      .post("https://document-verification.rushour0.repl.co/declineRequest", {
        to_email: owner,
        to_name: name,
        decline_reason: declineReason,
      })
      .catch((error) => console.log(error));

    setStateLoader("none");
    alert(`Refusal email sent to ${owner} successfully`);
  }

  async function verifyDocument({
    owner: userId,
    queryId,
    owner,
    name,
    prn,
    Prog: programme,
    docs,
    mode = "Online",
  }) {
    setStateLoader("block");

    try {
      const resp = await axios.post(
        "https://document-verification.rushour0.repl.co/verifyRequest",
        {
          query_id: queryId,
          to_email: owner,
          to_name: name,
          prn,
          programme,
          mode,
          docs,
        }
      );
    } catch (error) {
      console.error(error);
    }

    setStateLoader("none");
    setStatus("verification.exam@mitwpu.edu.in", queryId, verificationStatuses.VERIFIED);
    setStatus(userId, queryId, verificationStatuses.VERIFIED);
    alert(`Approval email sent to ${owner} successfully`);
  }

  useEffect(() => {
    try {
      // if (props.status === "Verified" || props.status === "Denied") {
      //   setstatusVerify(true);
      // }
      const element = document.getElementById("inputDelineAddress");
      element.innerHTML = declineReason;
    } catch (err) {}
  }, [declineReason]);

  return stateLoader === "block" ? (
    <Loader />
  ) : (
    <div>
      <div
        className="main_card_container"
        style={{
          background: props.color,
        }}
      >
        <div
          className="rounded-circle"
          style={{
            backgroundColor: colorScheme(props.status),
          }}
        ></div>
        <div className="admin_valueContainer">
          <h2 className="admin_card_heading">{props.date}</h2>
        </div>
        <div
          className="admin_valueContainer"
          style={{
            marginLeft: "7%",
            width: "17vw",
          }}
        >
          <h2 className="admin_card_heading" style={{ marginLeft: "-15%" }}>
            {props.submissionID}
          </h2>
        </div>
        <div className="admin_valueContainer" style={{ marginLeft: "0%" }}>
          <h2 className="admin_card_heading">{props.name}</h2>
        </div>
        <div className="admin_valueContainer">
          <h2 className="admin_card_heading">{props.prn}</h2>
        </div>
        <div className="admin_valueContainer">
          <h2 className="admin_card_heading" style={{ marginLeft: "20%" }}>
            {props.paymentStatus}
          </h2>
        </div>
        <div
          className="admin_valueContainer"
          style={{
            padding: "0.5% 0.5% 0.5% 1%",
            width: "11%",
            backgroundColor: "#316EBC",
            fontWeight: "400",
            marginLeft: "6%",
            marginRight: "5%",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "white",
            borderRadius: "3px",
          }}
        >
          <a
            className="link-primary_linkViewDocument ViewDocumentButton"
            variant="primary"
            onClick={handleShow}
            style={{
              textDecoration: "none",
              color: "white",
            }}
          >
            View document
          </a>
        </div>

        {/* Modal for Showing Full Information */}

        <Modal show={show} onHide={handleClose} animation={false}>
          {/* Header for the modal */}
          <div>
            <Modal.Header closeButton>
              <Modal.Title style={{ fontSize: "1.25rem" }}>
                ID : {props.submissionID}
              </Modal.Title>
              <p
                style={{ fontSize: "0.95rem", margin: 0, marginLeft: "2.6vw" }}
              >
                {props.status}
              </p>
            </Modal.Header>
          </div>
          {/*Main Body of the Modal */}

          <Modal.Body
            id="MainBodyContainer"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div
              style={{
                overflow: "auto",
                height: "300px",
              }}
            >
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p className="content">Query Date :</p>
                <p className="content">{props.date}</p>
              </div>
              <hr></hr>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p className="content">Name :</p>
                <p className="content">{props.name}</p>
              </div>
              <hr></hr>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p className="content">Email :</p>
                <p className="content">{props.email}</p>
              </div>
              <hr></hr>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p className="content">Agency Number :</p>
                <p className="content">{props.compContactNumber}</p>
              </div>
              <hr></hr>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p className="content">Agency Name :</p>
                <p className="content">{props.CompName}</p>
              </div>
              <hr></hr>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p className="content">Agency Email :</p>
                <p className="content">{props.CompEmail}</p>
              </div>
              <hr></hr>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p className="content">Designation :</p>
                <p className="content">{props.compContactPersonal}</p>
              </div>
              <hr></hr>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p className="content">University Name :</p>
                <p className="content">{props.Uni}</p>
              </div>
              <hr></hr>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p className="content">Program Name :</p>
                <p className="content">{props.Prog}</p>
              </div>
              <hr></hr>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p className="content">PRN :</p>
                <p className="content">{props.prn}</p>
              </div>
              <hr></hr>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p className="content">Graduation Date :</p>
                <p className="content">{props.PYear}</p>
              </div>
              <hr></hr>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p className="content">Document :</p>
                <p className="content">{props.docs}</p>
              </div>
              <hr></hr>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p className="content">NEFT :</p>
                <p className="content">{props.NEFT}</p>
              </div>
              <hr></hr>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p className="content">Submission Date :</p>
                <p className="content">{props.date}</p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ justifyContent: "center" }}>
            <Button
              disabled={disable}
              variant="primary"
              onClick={async () => {
                //setLoader(true);
                await getfile(props.owner, props.queryId);
                setDisable(true);
              }}
            >
              View Documents
            </Button>
            <Button
              disabled={declineButton}
              variant="danger"
              onClick={toggleWarningModal}
            >
              Decline Query Request
            </Button>

            <Button
              disabled={statusVerify}
              variant="success"
              onClick={() => {
                verifyDocument(props);
              }}
            >
              Verify Request
            </Button>

            <Button
              variant="primary"
              disabled={props.certFilename == null}
              onClick={async () => {
                window.open(await getCertURL(props.certFilename));
              }}
            >
              View Certificate
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal for warning */}
        <Modal
          className="warning-modal"
          show={isOpen}
          onHide={toggleWarningModal}
        >
          <div style={{ textAlign: "center", padding: "5%" }}>
            Do you want to decline Payment.
          </div>
          <div style={{ display: "flex", gap: "3%", justifyContent: "center" }}>
            <Button
              variant="primary"
              onClick={async () => {
                setdeclineButton(true);
              }}
            >
              Yes
            </Button>
            <Button onClick={toggleWarningModal}>No</Button>
          </div>
          {/* input textarea */}
          {declineButton && (
            <textarea
              rows="5"
              id="inputDeclineAddress"
              onChange={(e) => setDeclineReason(e.target.value)}
              placeholder="Enter your reason for declining the query. (Displayed to the user)"
              style={{ margin: "5% 0%" }}
            ></textarea>
          )}
          {declineButton && (
            <button
              className="btn btn-primary"
              onClick={() => {
                declineButtonClick(props);
              }}
            >
              {"Send"}
            </button>
          )}
        </Modal>
      </div>
    </div>
  );
}
